import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { Stack, Button, Select, FormControl, InputLabel, MenuItem, ListSubheader, ListItemText, OutlinedInput, Portal, ListItemButton, ListItemIcon } from '@mui/material';
import { addPositionsAction } from '../../../../../../services/request';
import { updateOrder } from '../../../../../../services/redux-actions';
import DeductionModal from './DeductionModal';
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
import DietModal from './DietModal';
import SupplementModal from './SupplementModal';

const AddPositionModal = ({ order, handleClose, formik, module }) => {
  const dispatch = useDispatch();
  const { seasonIdentifier } = useSelector(state => state.app);
  const { loading, mutate } = useMutation(addPositionsAction);
  const [positions, setPositon] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openDietModal, setOpenDietModal] = React.useState(false);
  const [openSupplementModal, setOpenSupplementModal] = React.useState(false);

  const handleChange = event => {
    setPositon(
      typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value
    );
  };

  const handleAddPositions = async () => {
    if (positions.length === 0) {
      return;
    }

    const data = {
      positions: []
    };
    const promotions = order.positions.promotions.filter(item => positions.includes(item.name));
    for (const item of promotions) {
      item.posType = 'promotion';
    }
    data.positions = [...data.positions, ...promotions];
    data.positions = [...data.positions, ...order.positions.transports.filter(item => positions.includes(item.name))];
    if (module !== 'zielone_szkoly') {
      formik.setFieldValue('positions', [...formik.values.positions, ...data.positions.map(p => ({ ...p, status: 'NEW' }))]);
      handleClose();
    } else {
      const { error, payload } = await mutate(order.id, data);
      if (!error) {
        toast.success('Pozycje zostały dodany');
        dispatch(updateOrder(payload));
        const newValues = formik.values;
        newValues.positions = _.isNil(payload.products) ? [] : payload.products.map(p => ({ status: 'OLD', ...p }));
        formik.resetForm({
          values: newValues
        });
        handleClose();
      } else {
        toast.error('Wystąpił błąd');
      }
    }
  };

  return (
    <>
      <FormControl sx={{ width: '100%', mb: 3 }}>
        <InputLabel id="demo-multiple-name-label">Pozycje</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          value={positions}
          onChange={handleChange}
          label="Pozycje"
          fullWidth
          input={<OutlinedInput label="Tag" />}
          renderValue={selected => selected.join(', ')}
          MenuProps={
            {
              PaperProps: {
                style: {
                  maxHeight: 280
                }
              }
            }
          }
        >
          <ListItemButton onClick={() => setOpen(true)}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText>Dodaj potrącenie</ListItemText>
          </ListItemButton>
          {['l_24_zs', 'l_25_zs'].includes(seasonIdentifier) ? <ListItemButton onClick={() => setOpenDietModal(true)}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText>Dodaj dietę</ListItemText>
          </ListItemButton> : null}
          {seasonIdentifier == 'l_25_zs' ? <ListItemButton onClick={() => setOpenSupplementModal(true)}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText>Dodaj dopłatę</ListItemText>
          </ListItemButton> : null}
          <ListSubheader>Promocje</ListSubheader>
          {order.positions.promotions.map((item, idx) => <MenuItem key={idx} value={item.name}>
            <ListItemText primary={`${item.name} - wartość ${item.gross_value} zł`} />
          </MenuItem>)}
          {/* <ListSubheader>Transport</ListSubheader>
          {order.positions.transports.map(item => <MenuItem key={item.id} value={item.name}>
            <ListItemText primary={`${item.name} - wartość ${item.gross_value} zł`} />
          </MenuItem>)} */}
        </Select>
      </FormControl>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button variant="outlined" style={{ flex: '0.4' }} onClick={handleClose}>Anuluj</Button>
        <Button variant="contained" style={{ flex: '0.4' }} onClick={handleAddPositions} disabled={loading}>Dodaj pozycje</Button>
      </Stack>
      {open ? <DeductionModal mainFormik={formik} handleClose={() => setOpen(false)} orderId={order.id} mutate={mutate} loading={loading}/> : null}
      {openDietModal ? <DietModal mainFormik={formik} handleClose={() => setOpenDietModal(false)} orderId={order.id} mutate={mutate} loading={loading}/> : null}
      {openSupplementModal ? <SupplementModal mainFormik={formik} handleClose={() => setOpenSupplementModal(false)} orderId={order.id} mutate={mutate} loading={loading}/> : null}

    </>
  );
};


export default AddPositionModal;
